import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customise-prescription',
  templateUrl: './customise-prescription.component.html',
  styleUrls: ['./customise-prescription.component.css']
})
export class CustomisePrescriptionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
